import WebpackerReact from "webpacker-react";
import { NotesPanel } from "n2-styles";

export default class PublicationJobsProductionData {
  edit() {
    WebpackerReact.setup({ NotesPanel });
  }
}
